import { render } from "./AboutAecomPage.vue?vue&type=template&id=42de28ee&scoped=true"
import script from "./AboutAecomPage.vue?vue&type=script&lang=js"
export * from "./AboutAecomPage.vue?vue&type=script&lang=js"

import "./AboutAecomPage.vue?vue&type=style&index=0&id=42de28ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42de28ee"]])

export default __exports__